<template>
  <div class="" style="background-color: whitesmoke !important;">
    <!-- <div v-if="isMobile" class="mobile-header">
      <v-avatar size="80" class="mb-4">
        <v-img :src="logo" :aspect-ratio="1"></v-img>
      </v-avatar>
      <h1 class="text-h4 font-weight-bold mb-2 text-center">{{ stateGlobal.institutionName }}</h1>
      <p class="text-subtitle-1 text-center text-medium-emphasis">Welcome to application portal</p>
    </div> -->

    <v-row
      class="test"
      justify="center"
      align-content="center"
      :class="{ 'mt-2': true, 'mt-4 mb-10': isMobile }"
    >
      <v-col cols="12" md="6">
        <x-card elevation="2" outlined>
          <v-card-title class="">
            <h2 :class="{ 'mx-0 px-0': isMobile }">
              {{ registering === true ? "New application" : "Login" }}
            </h2>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-alert
            type="warning"
            prominent
            class="mx-4 mb-2"
          >
            <strong>WAEC verification is currently unavailable.</strong>
            This is due to an upstream service disruption. Please try again later.
          </v-alert>

          <!-- <v-divider></v-divider> -->

          <v-card-text v-if="registering" justify-center class="text-center">
            <email-otp-verification
              v-if="registrationStep === 'otp' && registrationOtpRequired"
              :email="obj.emailAddress"
              :loading="loading"
              @verify="register"
              @resend="resendRegistrationOtp"
              @back="editRegistrationDetails"
            ></email-otp-verification>

            <template v-else>
            <v-select
                dense
                class="mt-4"
                item-text="id"
                required
                :rules="textRules"
                outlined
                :items="admissions"
                v-model="admission"
                return-object
                placeholder="Application type"
            >
              <template v-slot:item="{ item }">
                {{ item.applicationType.name + " " + item.session.name }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.applicationType.name + " " + item.session.name }}
              </template>
            </v-select>

            <v-form v-model="dataValid" ref="form">
              <div
                v-if="
                  admission != null &&
                  admission.applicationType.autoLoadUtme === true
                "
              >
                <v-text-field
                  class="text-center mt-4"
                  outlined
                  dense
                  placeholder="UTME REG / Applicant ID"
                  v-model="jambRegNumber"
                  required
                  :rules="textRules"
                ></v-text-field>
              </div>

              <div
                v-if="
                  admission != null &&
                  admission.applicationType.modeOfEntryEnabled === true
                "
              >
                <v-select
                  class="mt-4"
                  :items="modeOfEntries"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                  placeholder="Mode of entry"
                  v-model="obj.modeOfEntryId"
                  required
                  :rules="textRules"
                ></v-select>
              </div>

              <div>
                <v-text-field
                  class="mt-4"
                  required
                  :rules="emailRules"
                  outlined
                  dense
                  placeholder="Email address"
                  v-model.trim="obj.emailAddress"
                  :loading="emailAvailabilityStatus === 'checking'"
                  :success="emailAvailabilityStatus === 'available'"
                  :messages="emailAvailabilityMessage"
                  :error-messages="emailAvailabilityError"
                  @blur="checkEmailAvailability"
                ></v-text-field>
              </div>

              <div class="">
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  class="mt-4"
                  outlined
                  dense
                  placeholder="Password"
                  v-model="obj.password"
                  required
                  :rules="passwordRules"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </div>

              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                class="mt-4"
                outlined
                dense
                placeholder="Confirm Password"
                v-model="obj.confirmPassword"
                required
                :rules="textRules"
              ></v-text-field>

              <div class="">
                <div
                  v-if="registering"
                  class="d-flex flex flex-wrap basic--text text-sm"
                >
                  <div>
                    Already registered?
                    <a
                      class="primary--text"
                      href="#"
                      @click.prevent="toggleRegistration"
                      >Login</a
                    >
                  </div>
                </div>
                <div class="d-flex mt-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="ml-auto"
                    color="primary"
                    depressed
                    @click="submitData"
                    :disabled="!canProceedRegistration"
                    :loading="loading"
                    >Proceed</v-btn
                  >
                </div>
              </div>
            </v-form>
            </template>
          </v-card-text>

          <!--    Login      -->
          <v-card-text v-else>
            <v-form v-model="loginValid" ref="login" tabIndex="0">
              <v-alert v-if="!registering && usingOldReg" outlined type="info">
                {{ newRegMessage }}
              </v-alert>
              <v-text-field
                class="mt-4"
                outlined
                required
                :rules="textRules"
                dense
                placeholder="Email address / Applicant ID"
                v-model="user.username"
              ></v-text-field>

              <v-text-field
                :type="showPasswordLogin ? 'text' : 'password'"
                :append-icon="showPasswordLogin ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPasswordLogin = !showPasswordLogin"
                class="mt-4"
                required
                :rules="textRules"
                outlined
                dense
                placeholder="Password"
                v-model="user.password"
                @keyup.enter="login"
              ></v-text-field>
              <div>
                Not registered?
                <a
                  class="primary--text"
                  href="#"
                  @click.prevent="toggleRegistration"
                  >Register</a
                >
                or Forgot password?
                <a class="primary--text" href="/login">click here</a> and then
                click on forgot password
              </div>
            </v-form>
            <div class="d-flex">
              <v-btn
                class="ml-auto"
                color="primary"
                depressed
                @click="login"
                :disabled="!loginValid"
                :loading="loginLoading"
                >Login</v-btn
              >
            </div>
          </v-card-text>
        </x-card>
      </v-col>
    </v-row>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box
      :show="messageShow"
      :message="message"
      :type="messageType"
      v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import ValidationRules from "@/shared/ValidationRules";
import DateUtil from "@/shared/DateUtil";
import LoginUtil from "../../../../login/LoginUtil";
import Roles from "@/shared/Roles";
import Defaults from "shared/Defaults";
import Links from "shared/constants/Links";
import XCard from "@ui/components/XCard";
import EmailOtpVerification from "./EmailOtpVerification.vue";
export default {
  name: "Login",
  components: { MessageBox, LoadingDialog, XCard, EmailOtpVerification },

  data: () => ({
    obj: {},
    jambRegNumber: null,
    utmeYear: "",
    messageType: "",
    message: "",
    messageShow: false,
    loading: false,
    admissions: [],
    admission: null,
    modeOfEntries: [],
    registering: true,
    registrationStep: "details",
    emailAvailabilityStatus: "idle",
    emailAvailabilityEmail: null,
    emailAvailabilityRequestId: 0,
    years: DateUtil.getYearsArray(2010),
    dataValid: true,
    loginValid: true,
    loginLoading: false,
    textRules: ValidationRules.textRules,
    emailRules: ValidationRules.emailRules,
    passwordRules: ValidationRules.passwordRules,
    showPassword: false,
    showPasswordLogin: false,
    user: {
      applicant: true,
    },
    usingOldReg: false,
    newRegMessage: "",
    stateGlobal: {},
    logo: ''
  }),

  methods: {
    getAdmissions() {
      this.loading = true;
      Api.admission
        .getActiveAdmissions()
        .then((res) => {
          this.admissions = res.data;
        })
        .catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => (this.loading = false));
    },

    loadModeOfEntries() {
      if (this.admission != null) {
        this.modeOfEntries = [];
        Api.system
          .modeOfEntries(this.admission.session.programmeType.id)
          .then((res) => (this.modeOfEntries = res.data))
          .catch((err) => ErrorResolver.checkErrors(this, err));
      }
    },

    fetchGlobal() {

      Api.global.fetch().then((res) => {
        this.stateGlobal = res.data;
        this.logo = Defaults.api + Links.global.logo;
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    async submitData() {
      if (!this.canProceedRegistration) return;

      this.loading = true;
      try {
        if (this.admission.applicationType.autoLoadUtme === true) {
          await Api.applicants.validateUTME({
            registrationNumber: this.jambRegNumber,
            admissionId: this.admission.id,
          });
        }

        if (this.registrationOtpRequired) {
          await this.requestRegistrationOtp();
          this.registrationStep = "otp";
          this.showMessage("OTP sent to your email address");
        } else {
          await this.register();
        }
      } catch (err) {
        ErrorResolver.checkErrors(this, err);
      } finally {
        this.loading = false;
      }
    },

    requestRegistrationOtp() {
      return Api.applicants.requestOtp({
        recipient: this.obj.emailAddress,
        type: "email",
      });
    },

    async resendRegistrationOtp() {
      this.loading = true;
      try {
        await this.requestRegistrationOtp();
        this.showMessage("A new OTP was sent to your email address");
      } catch (err) {
        ErrorResolver.checkErrors(this, err);
      } finally {
        this.loading = false;
      }
    },

    async register(otp) {
      this.loading = true;
      const payload = {
        ...this.obj,
        admissionId: this.admission.id,
        jambRegNumber: this.jambRegNumber,
      };
      if (this.registrationOtpRequired && otp) payload.otp = otp;

      try {
        await Api.applicants.register(payload);
        this.showMessage("Registration was successful");
        this.registrationStep = "details";
        this.registering = false;
      } catch (err) {
        ErrorResolver.checkErrors(this, err);
      } finally {
        this.loading = false;
      }
    },

    showMessage(message, type = "success") {
      this.message = message;
      this.messageType = type;
      this.messageShow = true;
    },

    editRegistrationDetails() {
      this.registrationStep = "details";
    },

    toggleRegistration() {
      this.registering = !this.registering;
      this.registrationStep = "details";
    },

    isValidEmail(email) {
      return this.emailRules.every(rule => rule(email) === true);
    },

    async checkEmailAvailability() {
      const email = (this.obj.emailAddress || "").trim();
      if (!this.isValidEmail(email)) return;
      if (
        this.emailAvailabilityEmail === email &&
        ["available", "unavailable"].includes(this.emailAvailabilityStatus)
      ) return;

      const requestId = ++this.emailAvailabilityRequestId;
      this.emailAvailabilityStatus = "checking";
      this.emailAvailabilityEmail = null;
      try {
        const response = await Api.applicants.checkEmailAvailability(email);
        if (requestId !== this.emailAvailabilityRequestId || email !== (this.obj.emailAddress || "").trim()) return;
        this.emailAvailabilityEmail = email;
        this.emailAvailabilityStatus = response.data && response.data.available === true
          ? "available"
          : "unavailable";
      } catch (err) {
        if (requestId !== this.emailAvailabilityRequestId) return;
        this.emailAvailabilityStatus = "error";
        this.emailAvailabilityEmail = null;
        ErrorResolver.checkErrors(this, err);
      }
    },

    login() {
      // input must be valid
      if (!this.loginValid) return;

      this.loginLoading = true;
      Api.auth
        .login(this.user)
        .then((res) => {
          // if using old reg no.
          if (res.data.old) {
            this.usingOldReg = true;
            this.newRegMessage =
              "Use " + res.data.applicant + " as your username to login";
            return;
          }
          // check
          if (!Roles.contains(res.data.roles, Roles.Applicant)) {
            window.location.href = "/login";
          }
          // save to cookie
          LoginUtil.setAccessToken(res.data.jwt);
          LoginUtil.setRefreshToken(res.data.refreshToken);
          this.$router.push("application");
          // reload
          window.canReload = true;
        })
        .catch((err) => {
          ErrorResolver.checkErrors(this, err);
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
  },

  computed: {
    registrationOtpRequired() {
      const hostname = typeof window === "undefined"
        ? ""
        : (window.location.hostname || "").toLowerCase();
      return !hostname.startsWith("pg.nsuk");
    },

    canProceedRegistration() {
      const email = (this.obj.emailAddress || "").trim();
      return !!this.dataValid &&
        this.obj.password === this.obj.confirmPassword &&
        !this.loading &&
        !!this.admission &&
        this.emailAvailabilityStatus === "available" &&
        this.emailAvailabilityEmail === email;
    },

    emailAvailabilityMessage() {
      if (this.emailAvailabilityStatus === "checking") return ["Checking email availability…"];
      if (this.emailAvailabilityStatus === "available") return ["Email is available"];
      if (this.emailAvailabilityStatus === "error") return ["Could not verify this email. Leave the field and try again."];
      return [];
    },

    emailAvailabilityError() {
      return this.emailAvailabilityStatus === "unavailable"
        ? ["An applicant or student already uses this email address"]
        : [];
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  watch: {
    "obj.emailAddress": function (value) {
      const email = (value || "").trim();
      if (email === this.emailAvailabilityEmail) return;
      this.emailAvailabilityRequestId += 1;
      this.emailAvailabilityStatus = "idle";
      this.emailAvailabilityEmail = null;
    },

    admission: function (val) {
      this.$refs.form.reset()
      if (val != null && val.applicationType.modeOfEntryEnabled) {
        this.modeOfEntries = this.admission.applicationType.modeOfEntries
      }
    },
  },

  created() {
    this.getAdmissions();
    this.fetchGlobal()
  }, 
};
</script>

<style lang="css" scoped>
@media screen and (min-width: 320px) and (max-width: 800px) {
  h2 {
    margin-left: 15%;
    padding-bottom: 4%;
  }
  .sub {
    display: flex;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .test {
    position: absolute;
    width: 70%;
    margin-left: 7.8rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .test {
    width: 70%;
  }
}

/* Mobile Animations and Transitions */
@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  75% {
    transform: translateX(5px);
  }
}

.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInUp 0.5s ease-out;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

/* Base styles with mobile-first approach */
.bg-background {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
}

/* Mobile Header Styles */
.mobile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 1rem;
  animation: fadeIn 0.5s ease-out;
}

.mobile-header .v-avatar {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 3px solid white;
  animation: fadeInUp 0.8s ease-out;
}

.mobile-header h1 {
  color: var(--v-primary-darken1);
  animation: fadeInUp 0.8s ease-out 0.1s;
  opacity: 0;
  animation-fill-mode: forwards;
}

.mobile-header p {
  animation: fadeInUp 0.8s ease-out 0.2s;
  opacity: 0;
  animation-fill-mode: forwards;
}

/* Mobile Card Styles */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInUp 0.5s ease-out;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

@media (max-width: 600px) {
  .v-card {
    margin: 0 !important;
    border-radius: 20px 20px 0 0 !important;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 90vh;
    min-height: 50vh;
    overflow-y: auto;
    width: 100% !important;
  }
}

/* Form Field Animations */
.v-text-field {
  transition: all 0.3s ease;
  animation: fadeIn 0.5s ease-out;
}

.v-text-field:focus-within {
  transform: translateY(-2px);
}

/* Button Animations */
.v-btn {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.v-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
}

.v-btn:active::after {
  width: 200%;
  height: 200%;
}

/* Loading Animation */
.v-progress-circular {
  animation: pulse 1.5s infinite ease-in-out;
}

/* Error State Animation */
.v-alert[type="error"] {
  animation: shake 0.5s ease-in-out;
}

/* Touch Feedback */
.v-card,
.v-btn,
.v-text-field {
  -webkit-tap-highlight-color: transparent;
}

/* Mobile Form Group Spacing */
@media (max-width: 600px) {
  .form-group {
    margin-bottom: 16px;
  }

  .v-text-field {
    margin-bottom: 12px;
  }

  .v-card-title {
    font-size: 24px !important;
  }

  .v-card-subtitle {
    font-size: 16px !important;
  }
}
</style>
